import { NativeSelect } from '@mantine/core'
import { useTranslation } from 'react-i18next'

export const languageOptions = [
  { value: 'nl', label: 'Nederlands' }, { value: 'en', label: 'English' },
  { value: 'fr', label: 'Français' }, { value: 'de', label: 'Deutsch' },
]

export default function LanguageSelect() {
  const { t, i18n } = useTranslation()
  return <NativeSelect aria-label={t('Taal')} size="xs" value={i18n.language} onChange={event => i18n.changeLanguage(event.currentTarget.value)} data={languageOptions}/>
}
